import React, { useEffect, useRef, useState } from 'react';
import { Button } from '../Button/Button.js';
import { CountdownFormat } from '../CountdownFormat/CountdownFormat.js';
const styles = {"line":"ResendCode-module__line__2Igmm","time":"ResendCode-module__time__M5p07","announcement":"ResendCode-module__announcement__mzH5R"};
/**
 * The resend line under the code (Foundations · CodeInput board, frames D1, D5). Screen readers hear it only twice per
 * countdown: when the countdown starts and when resend becomes available. The visible line is not a live region, so
 * the ticking seconds are never read out.
 */
export function ResendCode({ secondsLeft, onResend, sending, countdownText, availableText, resendLabel, sendingLabel, availableAnnouncement }) {
    const isCounting = secondsLeft > 0;
    const [announcement, setAnnouncement] = useState('');
    const previousIsCountingRef = useRef(undefined);
    const countdownStartSecondsRef = useRef(secondsLeft);
    let line;
    // Runs after the first paint, so the status region changes from empty and the start is announced. The seconds are
    // the ones from when the countdown started, so ticking never changes the announced text; only a change between
    // counting and available, or new texts (such as another language), does.
    useEffect(() => {
        if (previousIsCountingRef.current !== isCounting) {
            previousIsCountingRef.current = isCounting;
            countdownStartSecondsRef.current = secondsLeft;
        }
        if (isCounting) {
            setAnnouncement(`${countdownText} ${CountdownFormat.format(countdownStartSecondsRef.current)}`);
        }
        else {
            setAnnouncement(availableAnnouncement);
        }
    }, [isCounting, secondsLeft, countdownText, availableAnnouncement]);
    if (isCounting) {
        line = (React.createElement("p", { className: styles.line },
            countdownText,
            " ",
            React.createElement("span", { className: styles.time }, CountdownFormat.format(secondsLeft))));
    }
    else {
        line = (React.createElement("p", { className: styles.line, "data-state": "available" },
            availableText,
            React.createElement(Button, { variant: "tertiary", label: resendLabel, loading: sending === true, loadingLabel: sendingLabel, onClick: onResend })));
    }
    return (React.createElement("div", { className: styles.resendCode },
        line,
        React.createElement("span", { className: styles.announcement, role: "status" }, announcement)));
}
//# sourceMappingURL=ResendCode.js.map